import useCommonStyles from "style/common";

export const PageWrapper: React.FC = props => {
  const commonClasses = useCommonStyles();
  return <div className={commonClasses.content}>{props.children}</div>;
};
